import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const PlayIcon = () => (
  <svg width="11" height="11" viewBox="0 0 24 24" fill="currentColor">
    <path d="M3 20.5v-17c0-.83 1-.96 1.4-.39l14 8.5c.37.23.37.77 0 1L4.4 21.39C4 22 3 21.83 3 21z" />
  </svg>
);

// Estilo de cada card (a ordem casa com t.apps.items)
const APP_STYLES = [
  { accent: 'card-purple', imgSrc: '/icone-app-termo.png', iconBg: 'none', href: 'https://play.google.com/store/apps/details?id=com.havel.termo_game' },
  { accent: 'card-orange', icon: '📅', iconBg: 'rgba(255,107,53,0.15)', href: '#' },
  { accent: 'card-teal', icon: '🛒', iconBg: 'rgba(45,220,180,0.15)', href: '#' },
  { accent: 'card-pink', icon: '💚', iconBg: 'rgba(255,61,127,0.15)', href: '#' },
];

const Apps = () => {
  const { t } = useLanguage();

  return (
    <section className="sec" id="apps">
      <div className="sec-header">
        <div className="sec-eyebrow">{t.apps.eyebrow}</div>
        <h2 className="sec-title">{t.apps.title}</h2>
        <p className="sec-sub">{t.apps.sub}</p>
      </div>

      <div className="apps-grid">
        {t.apps.items.map((app, i) => {
          const s = APP_STYLES[i];
          return (
            <div className={`app-card ${s.accent}`} key={app.name}>
              <div className="app-icon" style={{ background: s.iconBg, padding: s.imgSrc ? 0 : undefined }}>
                {s.imgSrc
                  ? <img src={s.imgSrc} alt={app.name} style={{ width: '62px', height: '62px', borderRadius: '14px', objectFit: 'cover', display: 'block' }} />
                  : s.icon}
              </div>
              <div className="app-cat">{app.cat}</div>
              <div className="app-name">{app.name}</div>
              <p className="app-desc">{app.desc}</p>
              <a href={s.href} className="gplay-btn">
                <PlayIcon />
                Google Play
              </a>
            </div>
          );
        })}

        {t.apps.coming.map((app, i) => (
          <div className="app-card app-coming" key={app.name}>
            <div className="app-icon" style={{ background: 'rgba(255,255,255,0.04)' }}>✨</div>
            <div className="app-cat">{t.apps.comingLabel}</div>
            <div className="app-name">{app.name}</div>
            <p className="app-desc">{app.desc}</p>
            <span className="soon-badge">{t.apps.soon}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Apps;
